jQuery(function ($) {
	const base = "gc-modal";

	// Open
	$("[data-popup-trigger]").on("click", function (e) {
		e.preventDefault();

		const target = $(this).attr("data-popup-trigger");
		$(`[data-popup-name=${target}]`).addClass(`${base}--visible`);
		$("body").addClass(`${base}-lock-body`);
	});

	// Close
	$(`.${base}`).on("click", function (event) {
		if (
			$(event.target).hasClass(`${base}`) ||
			$(event.target).hasClass(`${base}__close`)
		) {
			$(this).removeClass(`${base}--visible`);
			$("body").removeClass(`${base}-lock-body`);
		}
	});

	$(document).on("keyup", function (e) {
		if (e.key === "Escape") {
			$(`.${base}--visible`).removeClass(`${base}--visible`);
		}
	});
});
